import { appUser } from '@/utils'
import { MessageBox } from 'mint-ui'

export function $callingPhoneByWeb(options = {}) {
  send('callingPhoneByWeb', options)
}

// 约定  getXXX取值, setXXX赋值  XXX代表变量(自定义)
// 传值只接收基础类型,不包括boolean,返回值 string 类型
export function $dataHandle(options = {}, callback) {
  send('dataHandle', options, callback)
}
export function $toAppLogin(options = {}) {
  send('toAppLogin', options)
}
// 设置原生状态栏颜色   'style': 'light', 或者 'dark' , 'default'
export function $statusBarStyle(options = {}) {
  send('statusBarStyle', options)
}

// IOS专有  2022年06月02日  清楚  H5返回时 loading一直存在的问题
export function $IOScloseLoading(options = {}) {
  send('ylDOMContentLoaded', options)
}

// 跳转海报分享页面
export function $gotoPosterPage(options = {}) {
  send('gotoPosterPage', options)
}

// H5跳转
export function $openWebPage(options = {}) {
  send('openWebPage', options)
}

// 设置标题
export function $setTitle(options = {}) {
  send('setTitle', options)
}
// 获取分享海报url
export function $getShareImg(options = {}) {
  send('getShareImg', options)
}

// 跳转到APP课程界面
export function $jumpCourse(options = {}) {
  send('jumpCourse', options)
}

// 打开微信
export function $toShare(options = {}) {
  send('toShare', options)
}
// 打开微信发送小程序卡片
export function $toShareMini(options = {}) {
  send('toShareMini', options)
}
// 跳转应用宝
export function $toAppStore(options = {}) {
  send('toAppStore', options)
}

// 设置弹簧效果
export function $settingBounces(options = {}) {
  send('settingBounces', options)
}

// 关闭webview
export function $backToAppCallBack(options = {}) {
  send('backToAppCallBack', options)
}

// 激活卡券成功 通知native
export function $couponCashed(options = {}) {
  send('couponCashed', options)
}

// 原生支付
export function $payOrderNative(order, callback) {
  // 定义APP支付完成的回调
  const callbackName = 'payOrderNative_Callback' // AppPay.call(order, status)
  window[callbackName] = callback
  // 发生原生支付请求
  send('payOrderNative', order)
}
export function $paySuccess(order) {
  // 通知APP支付成功（生成权益后）
  send('paySuccess', order)
}

//  - 上报结果
export function $exerciseFinish(options = {}) {
  send('exerciseFinish', options)
}

//  - 个人 profile 页
export function $gotoProfile(options = {}) {
  send('gotoProfile', options)
}

// 2022年05月12日 合并账号完成通知原生
export function $mergeAccountFinish(options = {}) {
  send('mergeAccountFinish', options)
}

// 2022年05月12日 跳转小程序
export function $gotoMiniProgram(options = {}) {
  send('gotoMiniProgram', options)
}
export function $gotoMiniProgramV2(options = {}) {
  send('gotoMiniProgramV2', options)
}
/** 原生激活APP后，通知页面 **/
window.webviewDidAppear = function () {
  console.log('激活页面 webviewDidAppear')
}

/** 原生APP登录发生变化
 * 应该在这里,更新 appuser,但是可能会影响到其他模块,所以暂时先在具体页面重写处理
 * v522排行榜需求时添加
 * **/
window.loginDidChanged = function () {
  console.log('loginDidChanged')
}

export function send(name, data, callback) {
  console.log('appUser.version', appUser.version)
  const v = (appUser.version && appUser.version.replace(/\./g, '')) || 535 // 兼容web
  const isIntegral = location.href.indexOf('integral') >= 0
  console.log(v < 535 && name != 'backToAppCallBack' && isIntegral)
  // if (v < 535 && name != 'backToAppCallBack' && isIntegral) {
  //   return MessageBox({
  //     title: '提醒',
  //     message: '请先将APP升级至最新版本',
  //     confirmButtonText: '确定'
  //   })
  // }
  // WebViewJavascriptBridge 是原生给 window 注入的对象
  const bridge = window.WebViewJavascriptBridge
  if (bridge) {
    const json = data ? JSON.stringify(data) : null
    bridge.send(name, json, callback)
    const message = `SendToNative '${name}' // ${json}`
    console.log(message)
    // Toast({ message, position: 'bottom' })
  }
}
